module.exports = __webpack_public_path__ + "static/img/8.1b86e68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/8.png
// module id = Xlq8
// module chunks = 0